export default __webpack_public_path__ + "static/media/maulik-min.84ba4052.png";